import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { RolesUser } from '../../../../../enum/roles-user.enum';
import { AppState } from '../../../../../interfaces/app-state.interface';
import { User } from '../../../../../models/User';
import { SuitabilityState } from '../../../../../state-management/suitability/suitability.reducer';
import { BehaviorSubject } from 'rxjs';
import { AdvancedPlatformsActions } from '../../../../../state-management/advanced-platforms/advanced-platforms.action';
import { PlatformsIds } from '../../../../../enum/advanced-platforms/platforms-ids.enum';
import { IPlatform } from '../../../../../models/advanced-platforms/iplatform-model';
import { SettingsService } from '../../../../../services/settings/settings.service';
import { StorageService } from '../../../../../services/storage.service';
import { TrackingActions } from '../../../../../state-management/tracking/tracking.action';
import { Router } from '@angular/router';
import { ChatOnboardingService } from '../../../services/chat-onboarding.service';

@Component({
    selector: 'checklist',
    templateUrl: './checklist.component.html',
    styleUrls: ['./checklist.component.scss']
  })
  export class ChecklistComponent implements OnInit {
    @Input() public checklistStatus: BehaviorSubject<boolean>;
    public onboardingPlatforms: IPlatform;
    public basepath: string;
    public defaultPlatformQuerystring: string = 'toro-trader';

    public hasSuitability: boolean = false;
    public hasUserActived: boolean = false;
    public hasPlatformSubscription: boolean = false;
    public clickedPlatform: boolean = StorageService.getCookie('chat-onboarding-checklist-platform') === 'true';
    public clickedFirstOperation: boolean = StorageService.getCookie('chat-onboarding-checklist-firstOperation') === 'true';
  
    constructor(
      private store: Store<AppState>,
      private settingsService: SettingsService,
      public router: Router,
      public chatOnboardingService: ChatOnboardingService
      ) {
      this.basepath = this.settingsService.getConfigurationKeyValue('hubUrl');
      this.dispatchs();
    }
  
    ngOnInit() {
      this.getUserProfile();
      this.getSuitabiliy();
      this.getPlatformSubscribes();
    }

    public dispatchs() {
      this.store.dispatch({type: AdvancedPlatformsActions.getSubscribes});
      this.store.dispatch({type: AdvancedPlatformsActions.getPlatforms});
    }

    // Verifica se todos os passos foram completados
    public everythingComplete() {
      if(this.hasSuitability && 
        this.hasUserActived && 
        this.hasPlatformSubscription && 
        this.clickedPlatform && 
        this.clickedFirstOperation) {
          StorageService.setCookie('chat-onboarding-everything-complete', 'true', this.chatOnboardingService.expirationCookie('YEARLY'));
          return true
        }
    }

    // Recupera a plataforma trader assinada
    public getPlatformSubscribes() {
      this.store.select((state) => state.advancedPlatforms.list)
        .filter((platformList: IPlatform[]) => !!platformList.length)
        .subscribe((platformList: any) => {
          this.onboardingPlatforms = platformList
              .find((platform) => 
                platform.subscriptionStatus === 1 && (
                platform.id === PlatformsIds.ToroTraderProfit || 
                platform.id === PlatformsIds.ProfitPro ||
                platform.id === PlatformsIds.ToroTraderMobile))
                      
          this.hasPlatformSubscription = !!this.onboardingPlatforms;
        });
    }

    // Monta URL de configuração da plataforma
    public getPlatformConfiguration() {
        if(!this.onboardingPlatforms) {
          return this.basepath + '/plataformas';
        }

        this.clickedPlatform = this.hasPlatformSubscription;
        return this.basepath + this.onboardingPlatforms.card.activatedResum.routerLink
    }
  
    // Recupera os dados do perfil do usuário
    public getUserProfile() {
      this.store.select((state) => state.userProfile.user)
        .filter((user: User) => user && !user.pending)
        .subscribe((user) => {
            this.hasUserActived = user.profile === RolesUser.Activated;
        });
    }
  
    // Recupera os dados do perfil do usuário
    public getSuitabiliy() {
      this.store.select((state) => state.suitability)
      .filter((suitability: SuitabilityState) => suitability.profile && !suitability.pending)
      .subscribe((suitability) => {
          this.hasSuitability = suitability.profile.profile > 1;
      });
    }
  
    public openPlatformPage() {
    this.sendTracking('Element Clicked', {
        'Product Area Origin': window.location.pathname,
            'Element': 'Etapa 4',
            'Group': 'Onboarding Trader',
            'Scenario': 'Checklist iniciante',
            'Text': 'Configure sua plataforma',
            'Time Responsável': 'Brooklyn Dumbo',
        })
      StorageService.setCookie('chat-onboarding-checklist-platform', 'true', this.chatOnboardingService.expirationCookie('YEARLY'));
      const url = this.getPlatformConfiguration();
      window.open(url, '_blank');
    }
  
    public openTradingPlatform() {
        this.sendTracking('Element Clicked', {
            'Product Area Origin': window.location.pathname,
            'Element': 'Etapa 3',
            'Group': 'Onboarding Trader',
            'Scenario': 'Checklist iniciante',
            'Text': 'Assine uma plataforma de trading',
            'Time Responsável': 'Brooklyn Dumbo',
        })
        this.router.navigate(['minha-conta/plataformas']);
    }

    public openTransferResources() {
        this.sendTracking('Element Clicked', {
            'Product Area Origin': window.location.pathname,
            'Element': 'Etapa 2',
            'Group': 'Onboarding Trader',
            'Scenario': 'Checklist iniciante',
            'Text': 'Transfira recursos para a sua conta',
            'Time Responsável': 'Brooklyn Dumbo',
        })
        this.router.navigate(['/home/transferencia']);
    }

    public openSuitabilityPage() {
        this.sendTracking('Element Clicked', {
            'Product Area Origin': window.location.pathname,
            'Element': 'Etapa 1',
            'Group': 'Onboarding Trader',
            'Scenario': 'Checklist iniciante',
            'Text': 'Defina seu Perfil de Investidor',
            'Time Responsável': 'Brooklyn Dumbo',
        })
        this.router.navigate(['/perfil']);
    }

    public openFirstOperationPage() {
        this.sendTracking('Element Clicked', {
            'Product Area Origin': window.location.pathname,
            'Element': 'Etapa 5',
            'Group': 'Onboarding Trader',
            'Scenario': 'Checklist iniciante',
            'Text': 'Veja como fazer sua primeira operação',
            'Time Responsável': 'Brooklyn Dumbo',
        })
      StorageService.setCookie('chat-onboarding-checklist-firstOperation', 'true', this.chatOnboardingService.expirationCookie('YEARLY'));
      this.clickedFirstOperation = true;
      window.open(this.basepath + '/aprenda/day-trade-para-iniciantes/1/2', '_blank');
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    };
  }
  